import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/server_www/layouts/default.vue").then(m => m.default || m))
}